
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateScreendeviceDtoFormGroup() {
return new FormGroup({
    businessunitId: new FormControl<number | undefined>(undefined, [Validators.required]),
    uniqueIdentifier: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    ipAddress: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    ipAddressInternal: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    confirmed: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    startUpTime: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    shutDownTime: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    description: new FormControl<string | undefined>(undefined),
    monday: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    tuesday: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    wednesday: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    thursday: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    friday: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    saturday: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    sunday: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    alwaysOn: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    restartAt: new FormControl<string | undefined>(undefined),
})
;
}
      